export const apiUrl = process.env.REACT_APP_API_URL

export const logoutUrl = `${apiUrl}/auth/logout`
export const loginUrl = `${apiUrl}/auth/google`
export const signupUrl = [apiUrl, 'auth', 'google', 'signup'].join('/')
